import React, { useEffect, useState } from "react";
import { listProduct } from "../redux/actions/productActions";
import { listCategoryDiscounts } from "../redux/actions/categoryDiscountActions";
import { useSelector, useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import Product from "../components/Product";
import { Row, Col } from "react-bootstrap";
import Loading from "../components/Loading";
import Message from "../components/Message";
import Meta from "../components/Meta";
import Paginate from "../components/Paginate";
import HeroSection from "../components/HeroSection";
import FilterDrawer from "../components/FilterDrawer";
import { useGlobalLoading } from "../context/GlobalLoadingContext";
import DiscountPopup from "../components/DiscountPopup";

const HomeScreen = () => {
  let params = useParams();
  const keyword = params.keyword;
  const pageNumber = params.pageNumber || 1;

  const dispatch = useDispatch();

  const [selectedCategory, setSelectedCategory] = useState([]);
  const [selectedPrices, setSelectedPrices] = useState([]); // NEW

  const [showFilter, setShowFilter] = useState(false);
  const [showDiscountPopup, setShowDiscountPopup] = useState(false);
  const [productRequestStarted, setProductRequestStarted] = useState(false);

  const productList = useSelector((state) => state.productList);
  const { products, loading, error, page, pages } = productList;
  const { startLoading, stopLoading } = useGlobalLoading();

  const categoryDiscountList = useSelector(
    (state) => state.categoryDiscountList,
  );
  const { discounts = [] } = categoryDiscountList;

  useEffect(() => {
    setProductRequestStarted(true);

    dispatch(
      listProduct(
        keyword,
        pageNumber,
        selectedCategory,
        selectedPrices, // NEW
      ),
    );
  }, [dispatch, keyword, pageNumber, selectedCategory, selectedPrices]);

  useEffect(() => {
    dispatch(listCategoryDiscounts());
  }, [dispatch]);

  useEffect(() => {
    if (loading) {
      startLoading();
    } else {
      stopLoading();
    }
  }, [loading, startLoading, stopLoading]);

  useEffect(() => {
    if (!productRequestStarted || loading) {
      return;
    }

    const navigation = performance.getEntriesByType("navigation")[0];

    const isRefresh = navigation?.type === "reload";

    const hasShownPopup = sessionStorage.getItem("syukra_discount_popup_shown");

    if (!hasShownPopup) {
      setShowDiscountPopup(true);

      sessionStorage.setItem("syukra_discount_popup_shown", "true");

      return;
    }

    if (isRefresh) {
      setShowDiscountPopup(true);
    }
  }, [productRequestStarted, loading]);

  return (
    <>
      {showDiscountPopup && (
        <DiscountPopup onClose={() => setShowDiscountPopup(false)} />
      )}

      <Meta title="SYUKRA" />
      <HeroSection />

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <h3>Latest Products</h3>

        {/* FILTER BUTTON */}
        <button
          className="filter-toggle-btn"
          onClick={() => setShowFilter(true)}
        >
          <i className="fas fa-filter"></i> Filter
        </button>
      </div>
      {/* FILTER DRAWER */}
      <FilterDrawer
        show={showFilter}
        onClose={() => setShowFilter(false)}
        setSelectedCategory={setSelectedCategory}
        setSelectedPrices={setSelectedPrices} // NEW
      />

      <div style={{ minHeight: "180vh" }}>
        <Row className="gx-3 gx-md-4 gx-lg-5">
          {" "}
          {/* no justify-content-* here */}
          {loading ? null : error ? (
            <Message variant="danger">{error}</Message>
          ) : products.length === 0 && keyword ? (
            <Message>No products found for "{keyword}"</Message>
          ) : (
            products.map((product) => (
              <Col
                xs={6}
                sm={6}
                md={4}
                lg={3}
                xl={3}
                key={product._id}
                className="p-1 p-sm-2 p-md-2 p-lg-2"
              >
                <Product product={product} categoryDiscounts={discounts} />
              </Col>
            ))
          )}
        </Row>
      </div>
      <Paginate page={page} pages={pages} keyword={keyword ? keyword : ""} />
    </>
  );
};

export default HomeScreen;
